import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { TableStateLayout } from '../../shared/TableStateLayout';
import { PAIR_ROW_CLASS, PIE_ROW_CLASS } from './overviewLayout';
import { EmptyNote } from './StackedBar';

const CARD = 'rounded-xl border border-gray-200 bg-white p-5';
const PULSE = 'rounded bg-gray-200 animate-pulse';

function SkeletonCard({ heightClassName }: { heightClassName: string }) {
    return (
        <div className={`${CARD} flex flex-col gap-4 ${heightClassName}`}>
            <div className={`h-3.5 w-40 ${PULSE}`} />
            <div className={`h-3 w-full ${PULSE}`} />
            <div className={`h-3 w-3/4 ${PULSE}`} />
            <div className={`h-3 w-1/2 ${PULSE}`} />
        </div>
    );
}

const ROW_SLOTS = 4;
// Match the loaded rows, so the range cards below don't jump when the live overview lands.
const PIE_CARD_HEIGHT = 'h-[474px]';
const LIVE_PAIR_ROW_HEIGHT = 'h-[326px]';

function slotKeys(count: number): number[] {
    return Array.from({ length: count }, (_, index) => index);
}

export function PieRowSkeleton() {
    return (
        <div className={PIE_ROW_CLASS} aria-busy="true" aria-label="Loading live breakdowns">
            {slotKeys(ROW_SLOTS).map((slot) => (
                <SkeletonCard key={slot} heightClassName={PIE_CARD_HEIGHT} />
            ))}
        </div>
    );
}

export function LivePairSkeleton() {
    return (
        <div className={PAIR_ROW_CLASS} aria-busy="true" aria-label="Loading live workload">
            <SkeletonCard heightClassName={LIVE_PAIR_ROW_HEIGHT} />
            <SkeletonCard heightClassName={LIVE_PAIR_ROW_HEIGHT} />
        </div>
    );
}

const HISTORY_FAILED_NOTE = "Couldn't load this range.";

// Body of a range-driven card before its first range arrives, or when that load failed.
export function HistoryFallback({ failed }: { failed: boolean }) {
    if (failed) {
        return <EmptyNote>{HISTORY_FAILED_NOTE}</EmptyNote>;
    }
    return (
        <div className="flex flex-col gap-3 py-2" aria-busy="true" aria-label="Loading range">
            <div className={`h-3 w-full ${PULSE}`} />
            <div className={`h-3 w-3/4 ${PULSE}`} />
            <div className={`h-3 w-1/2 ${PULSE}`} />
        </div>
    );
}

export function OverviewErrorState({ onRetry }: { onRetry: () => void }) {
    return (
        <div className="grid flex-1 place-items-center py-16">
            <TableStateLayout
                icon={ExclamationTriangleIcon}
                title="Couldn't load the live workload"
                text="Something went wrong fetching the DM workload. Try again."
                actionLabel="Retry"
                onAction={onRetry}
            />
        </div>
    );
}
